"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _List = require("./List");

var _userProfile = require("user-profile");

var _decorators = require("decorators");

var _AccountList = require("./AccountList");

var _class, _descriptor, _descriptor2, _descriptor3, _temp;

var TopicSubmittedItem = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(TopicSubmittedItem, _Component);

  function TopicSubmittedItem() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, TopicSubmittedItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(TopicSubmittedItem)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "item", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "onSelected", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "asLink", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(TopicSubmittedItem, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_List.NotificationItem, {
        asLink: this.asLink,
        onSelected: this.onSelected,
        item: this.item,
        overlayType: "success",
        overlay: "date_range"
      }, _react.default.createElement(_AccountList.Account, {
        account: this.item.account
      }), ' has submitted the event ', _react.default.createElement("span", {
        className: "catalogItem"
      }, this.item.catalogItem.title), '.');
    }
  }]);
  return TopicSubmittedItem;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "onSelected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "asLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
})), _class);
exports.default = TopicSubmittedItem;